import { BsPeople } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditCrm = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsPeople',
				label: 'people',
				component: BsPeople,
			}}
			defaultTheme="blue"
			widgetType="crm"
		/>
	);
};

export default EditCrm;
